export default __webpack_public_path__ + "static/media/celular-proxxima.f2914cc0.png";